export function getdata() {
	let obj = {
		searchlist: [{
			prop: "tes1",
			label: '最近操作时间',
			type: "date",
			valueformat: 'yyyy-MM-dd' 
		},{
			prop: "tes2",
			label: '任务批次号',
			type: "input"
		},{
			prop: "tes3",
			label: '处理状态',
			type: "select"
		}],
		searchdata:{
			tes1:"",
			tes2:"",
			tes3:"",
		},
		headData: [{
				title: '任务批次号',
				prop: 'tes1',
				width: '220',
				issort: true,
			},
			{
				title: '最近执行时间',
				prop: 'tes2',
				width: '150',
				issort: true,
			},
			{
				title: '任务完成时间',
				prop: 'tes3',
				width: '150',
				issort: true,
			},
			{
				title: '处理状态',
				prop: 'tes4',
				width: '120',
				showFilter: true,
				custom:true,
				checkList: [],
				dataList: [
					{
						name: "是",
						code: "0"
					},
					{
						name: "否",
						code: "1"
					},
				]
			},
			{
				title: '修复内容',
				prop: 'tes5',
				width: '320',
				issort: true,
			},
			{
				title: '修复发票数量',
				prop: 'tes6',
				width: '220',
				issort: true,
				align:"right"
			},
			{
				title: '错误原因',
				prop: 'tes7',
				width: '200',
			},
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
 